import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { IframeCategoryDetailsComponent } from './category-details/category-details.component';
import { OptionsIframeIntroductionComponent } from './introduction/options-introduction.component';
import { OptionsIframeComponent } from './options-iframe.component';
import { OptionsIframeSummaryComponent } from './summary/iframe-summary.component';
import { IframePackagesComponent } from './packages/packages.component';

export const optionsIframeRoutes: Routes = [
  {
    path: 'project/:projectId/token/:tokenId',
    component: OptionsIframeComponent,
    children: [
      {
        path: 'category/:categoryId',
        component: IframeCategoryDetailsComponent,
      },
      {
        path: 'category/:categoryId/introduction',
        component: OptionsIframeIntroductionComponent,
      },
      {
        path: 'summary',
        component: OptionsIframeSummaryComponent,
      },
      {
        path: 'packages',
        component: IframePackagesComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(optionsIframeRoutes)],
  exports: [RouterModule],
})
export class OptionsIframeRoutingModule { }
